export const RECOMPUTE_GROUP_BALANCE_START =
  'RECOMPUTE_GROUP_BALANCE_START';
export const RECOMPUTE_GROUP_BALANCE_SUCCESS =
  'RECOMPUTE_GROUP_BALANCE_SUCCESS';
export const RECOMPUTE_GROUP_BALANCE_FAILED =
  'RECOMPUTE_GROUP_BALANCE_FAILED';
